import PropTypes from 'prop-types';
import { always, equals, ifElse } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';
import { useSelector } from 'react-redux';

import { getCompanyFromToken } from '@gef-ui/delegations/selectors';
import { getOriginalUserCookies } from '@gef-ui/delegations/utils';
import AppLoader from '@gef-ui/material/components/AppLoader';

import { FETCH_REPRESENTED_USER_INFO_PATH, FETCH_USER_INFO_PATH } from 'app/configurator/constants';
import { getIsPostInitLoaderActive } from 'app/configurator/selectors';
import { configJSON } from 'features/common/fetch/beEndpoints';
import { getFetchState } from 'features/common/fetch/selectors';

const InitLoader = ({ children }) => {
	const companyFromToken = useSelector(getCompanyFromToken);

	const configFetchState = useSelector((state) => getFetchState(configJSON)(state));
	const initUserInfoFetchState = useSelector(getFetchState(FETCH_USER_INFO_PATH));
	const initRepresentedUserInfoFetchState = useSelector(getFetchState(FETCH_REPRESENTED_USER_INFO_PATH));

	const isPostInitLoaderActive = useSelector(getIsPostInitLoaderActive);

	const getInitFetchLoaded = ifElse(
		equals(true),
		always(initUserInfoFetchState.loaded && initRepresentedUserInfoFetchState.loaded),
		always(initUserInfoFetchState.loaded || initRepresentedUserInfoFetchState.loaded),
	);

	const { originalUser } = getOriginalUserCookies() || {};

	const isInitAppLoaded = getInitFetchLoaded(isNilOrEmpty(originalUser) || isNilOrEmpty(companyFromToken));
	const loaded = configFetchState.loaded && isInitAppLoaded && !isPostInitLoaderActive;

	return !loaded ? <AppLoader /> : children;
};

InitLoader.propTypes = {
	children: PropTypes.any,
};

export default InitLoader;
